import { useCallback, useEffect, useState } from 'react';
import { container } from 'tsyringe';
import { useSubject } from '@base/utils/helpers';
import { IPlayer, IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
// import { BasePreferences } from '@base/features/preferences/model/types';

export const useRating = () => {
  const [currentRating, setCurrentRating] = useState<undefined | number>(1);
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const playersChanged = useSubject(playersOnlineRepository.onInOutPlayer);
  const pid = playersOnlineRepository.me?.pid;

  const getCurrentUser = useCallback((): IPlayer | undefined => {
    const players = playersOnlineRepository.getPlayersOnline();
    if (!players) return undefined;
    const player = players.get(Number(pid));
    if (player) return player;
  }, [pid, playersChanged, playersChanged]);

  useEffect(() => {
    const player = getCurrentUser();
    if (!player) return;
    const rating = player.getRating();
    if (rating === currentRating) return;
    else {
      setCurrentRating(rating);
    }
  }, [playersChanged, getCurrentUser, currentRating]);

  return currentRating;
};
